import { defineDocConfig } from './utils';

export const polyneuroDocumentTypes = defineDocConfig([
  {
    name: 'diagnosis',
    subTypes: ['diagnosis', 'polyneuroSymptoms', 'polyneuroEtiology', 'polyneuroUnderlyingCondition'],
  },
  { name: 'medication', subTypes: ['medication', 'adverseEffect'] },
  {
    name: 'procedure',
    subTypes: ['procedure'],
    subTypesFiltering: { procedure: d => d?.code?.code === '19647005' },
  },
  { name: 'imaging', subTypes: ['mri', 'nerveUltrasound'] },
  { name: 'clinicalstudy', subTypes: ['enmg'], title: 'polyneuro.title' },
  { name: 'examination' },
  { name: 'polyneuroDiagnosticExams', subTypes: ['csfExam', 'nerveBiopsy', 'skinBiopsy'] },
  { name: 'lifestyle' },
  { name: 'background', subTypes: ['background', 'measurement'] },
]);
